import React, { useMemo } from 'react';
import { StateManagerContext } from './provider';
export function useCarData() {
    var _a;
    if (typeof window === 'undefined') {
        return (_a = useStateManager()) === null || _a === void 0 ? void 0 : _a.getConfiguredCarData();
    }
    var carData = React.useContext(StateManagerContext).carData;
    return useMemo(function () { return carData; }, [carData]);
}
export function useIsLoading() {
    if (typeof window === 'undefined') {
        return false;
    }
    var isLoading = React.useContext(StateManagerContext).isLoading;
    return useMemo(function () { return isLoading; }, [isLoading]);
}
export function useStateEvent() {
    var stateEvent = React.useContext(StateManagerContext).stateEvent;
    return useMemo(function () { return stateEvent; }, [stateEvent]);
}
export function useStateManager() {
    var stateManager = React.useContext(StateManagerContext).stateManager;
    return useMemo(function () { return stateManager; }, [stateManager]);
}
//# sourceMappingURL=hooks.js.map